import { ApolloError } from '@apollo/client';
import { DeleteRodRequestErrorCode } from '@bechtel/types';

export type DeleteRodRequestErrorType = DeleteRodRequestErrorCode | ApolloError;

export interface DeleteRodRequestErrorProps {
  error: DeleteRodRequestErrorType;
  close: () => void;
}
